import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_05 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '5' }));
  }, []);

  const titleList = ['전통시장', '대중교통', '도서공연비', '신용카드', '직불카드', '제로페이'];

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>현금영수증 입력 상세 내역</p>
        <Table01
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.includes('현금영수증'))}
        />
      </div>
      {titleList.map((_item, index) => (
        <div key={index} className={'ntsResultBox'}>
          <p className={'body2Bold subPoint3 ntsResultTitle'}>{_item} 상세 내역</p>
          <Table02
            ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf(_item) != -1)}
          />
        </div>
      ))}
    </div>
  );
};

export default NtsResult_05;

const Table01 = ({ ntsResult }) => {
  const headList = [
    { name: '사용자', width: '25%', key: 'htmPerNm' },
    { name: '사용자 주민번호', width: '35%', key: 'htmRegNum' },
    { name: '월', width: '15%', key: 'htmMm2' },
    { name: '공제대상금액', width: '25%', key: 'htm001', align: 'right' },
    // { name: '반영유무	', width: '63px', key: 'htmDesc1' },
    // { name: '사유', width: '287px', key: 'htmDesc2' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{
              borderTop: '1px solid #D9D9D9',
              width: item.width,
              flex: 'none',
            }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.map((item, index) => (
        <div key={index} className="displayFlex tableTr">
          {headList.map((header, _index) => (
            <div
              className="tableBody captionMedium"
              key={_index}
              style={{
                justifyContent: header.align,
                width: header.width,
                flex: 'none',
              }}>
              {item[header.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headList = [
    { name: '사용자', width: '15%', key: 'htmPerNm' },
    { name: '사용자 주민번호', width: '17%', key: 'htmRegNum' },
    { name: '상호', width: '25%', key: 'htm004' },
    { name: '사업자번호', width: '23%', key: 'htm003' },
    { name: '공제대상금액', width: '20%', key: 'htm001' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{
              borderTop: '1px solid #D9D9D9',
              width: item.width,
              flex: 'none',
            }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.map((item, index) => (
        <div key={index} className="displayFlex tableTr">
          {headList.map((header, _index) => (
            <div
              className="tableBody captionMedium"
              key={_index}
              style={{
                justifyContent: header.align,
                width: header.width,
                flex: 'none',
              }}>
              {item[header.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
